import { PlanTreatmentsService } from "./plan-treatments.service";
import { Store } from "@ngrx/store";
import * as PriceActions from "../../price/price.actions";
import * as fromRoot from "../../reducers";
import "rxjs/add/operator/switchMap";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
var PriceManagerService = /** @class */ (function () {
    function PriceManagerService(store, treatmentsService) {
        var _this = this;
        this.store = store;
        this.treatmentsService = treatmentsService;
        this.pricesConfiguration$ = new BehaviorSubject([]);
        this.createPricesConfiguration();
        // dispatch action to load prices
        this.store.dispatch(new PriceActions.LoadPricesAction());
        this.store
            .select(fromRoot.getPrices)
            .switchMap(function (prices) {
            return Observable.of(_this.defaultConfiguration.map(function (_configuration) {
                var configuration = Object.assign({}, _configuration);
                // simple price
                if (_configuration.type === "simple") {
                    configuration["price"] = prices[_configuration.identifier]
                        ? prices[_configuration.identifier]
                        : null;
                }
                else {
                    // convert array to object and merge with the one received from the service
                    // let optionsHashMap = _configuration.variants.options.reduce((map, obj) => { map[obj] = 0; return map; }, {});
                    configuration.variants = Object.assign({}, _configuration.variants);
                    configuration.variants.options =
                        _configuration.variants.options.map(function (option) {
                            return {
                                value: option,
                                price: null,
                            };
                        });
                    if (prices[_configuration.identifier]) {
                        configuration.variants.options.map(function (option) {
                            return (option.price =
                                prices[_configuration.identifier].variants.options[option.value]);
                        });
                    }
                }
                return configuration;
            }));
        })
            .subscribe(this.pricesConfiguration$);
    }
    PriceManagerService.prototype.getPricesConfiguration = function () {
        return this.pricesConfiguration$;
    };
    PriceManagerService.prototype.getDeltaUpdate = function (treatmentPrice) {
        // transform data back to API format
        if (treatmentPrice.type === "simple") {
            return _a = {},
                _a[treatmentPrice.identifier] = +treatmentPrice.price,
                _a;
        }
        else {
            return _b = {},
                _b[treatmentPrice.identifier] = {
                    variants: {
                        identifier: treatmentPrice.variants.identifier,
                        options: treatmentPrice.variants.options.reduce(function (map, obj) {
                            map[obj.value] = +obj.price;
                            return map;
                        }, {}),
                    },
                },
                _b;
        }
        var _a, _b;
    };
    PriceManagerService.prototype.updatePrices = function (prices) {
        this.store.dispatch(new PriceActions.SavePricesAction(prices));
    };
    PriceManagerService.prototype.computePrice = function (treatmentItem) {
        var _this = this;
        return this.pricesConfiguration$
            .filter(function (prices) { return Object.keys(prices).length > 0; })
            .flatMap(function (prices) {
            var treatmentClass = _this.treatmentsService.getClassForTreatment(treatmentItem.treatment);
            var priceConfiguration = prices.filter(function (configuration) {
                return configuration.identifier === treatmentItem.treatment;
            })[0];
            return Observable.of(treatmentClass.computePrice(treatmentItem, priceConfiguration));
        });
    };
    /**
     * Create the price configuration for each treatment
     */
    PriceManagerService.prototype.createPricesConfiguration = function () {
        this.defaultConfiguration = this.treatmentsService
            .getTreatmentClasses()
            .map(function (treatmentClass) { return treatmentClass.getPriceConfiguration(); });
    };
    return PriceManagerService;
}());
export { PriceManagerService };



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/plan-price.service.ts.pre-build-optimizer.js